import type { SearchCacheBackend } from "../../types/CacheBackend"

export const MemoryCache = <V>(): SearchCacheBackend<V> => {
  const cache = new Map<string, V>()

  return {
    startswith: async (prefix?: string) =>
      Object.fromEntries(
        prefix
          ? [...cache.entries()].filter(([key]) => key.startsWith(prefix))
          : cache.entries()
      ),
    get: async (key: string) => cache.get(key),
    set: async (key: string, value: V) => void cache.set(key, value),
    delete: async (key: string) => void cache.delete(key),
    clear: async () => cache.clear(),
    exists: async (key: string) => cache.has(key),
  }
}
